import type { CommentData } from '@liveblocks/client'
import { useAddReaction, useRemoveReaction } from '@liveblocks/react'

import { useFrequentlyUsedEmojis } from '@/hooks/use-frequently-used-emojis'

import { type EventProperties, useTrackCallback } from '@/lib/analytics/events'

export const useCommentReactions = (
  comment: CommentData,
  isReply = false,
  trackingProps?: EventProperties,
) => {
  const addReaction = useAddReaction()
  const removeReaction = useRemoveReaction()
  const { emojis: frequentEmojis, record } = useFrequentlyUsedEmojis()
  const trackAdded = useTrackCallback('assessment.comment.reaction.added')
  const trackRemoved = useTrackCallback('assessment.comment.reaction.removed')

  const add = (emoji: string) => {
    addReaction({ threadId: comment.threadId, commentId: comment.id, emoji })
    record(emoji)
    trackAdded({ ...trackingProps, comment_id: comment.id, emoji, is_reply: isReply })
  }

  const remove = (emoji: string) => {
    removeReaction({ threadId: comment.threadId, commentId: comment.id, emoji })
    trackRemoved({ ...trackingProps, comment_id: comment.id, emoji, is_reply: isReply })
  }

  const toggle = (emoji: string, reacted: boolean) => (reacted ? remove(emoji) : add(emoji))

  return { frequentEmojis, add, toggle }
}
